<div class="documentBox">
<!-- Selection -->
<!-- <mat-card class="filter selection">
    <div class="sortview">
        Items Selected <span class="count">2</span>
    </div>
    <div class="selectact">
        <button mat-button color="primary">
            <mat-icon>delete_outline</mat-icon> Delete
        </button>
    </div>
</mat-card > -->
<!-- Selection -->


<!-- Filter -->
<mat-card  class="filter">
    <div class="sortview">
        <div class="sortby">

            <mat-form-field>
                <mat-label>Sort by</mat-label>
                <mat-select value="">
                    <mat-option value="">All</mat-option>
                    <mat-option value="">Started</mat-option>
                    <mat-option value="">Accepted</mat-option>
                    <mat-option value="">Completed</mat-option>
                    <mat-option value="">Pending</mat-option>
                    <mat-option value="">Unavailable</mat-option>
                    <mat-option value="">Rescheduled</mat-option>
                    <mat-option value="">Cancelled</mat-option>
                    <mat-option value="">Other</mat-option>
                </mat-select>
            </mat-form-field>

        </div>
        <!-- <div class="view_list">
              <button mat-icon-button  [ngClass]="{'active': list}" mat-icon-button (click)="showList()"  ><mat-icon>format_list_bulleted</mat-icon></button>
              <button mat-icon-button [ngClass]="{'active': grid}" (click)="showGrid()" ><mat-icon>apps</mat-icon></button>       
          </div> -->
    </div>
    <!-- (click)="createNewTask(showCreateTask)" -->
    <div class="actbtn">
        <button mat-flat-button color="primary" [routerLink]="'/core/process'" >
            Create PI
        </button>
    </div>
</mat-card >
<!-- Filter -->


<mat-card class="table">
    <table class="mat-table">
        <tr class="mat-header-row">
            <th class="mat-header-cell w-60">
                <mat-checkbox color="primary"></mat-checkbox>
            </th>
            <th class="mat-header-cell">Process Name</th>
            <th class="mat-header-cell">Tasks Linked</th>
            <th class="mat-header-cell ">Created By</th>
            <th class="mat-header-cell ">Status</th>
            <th class="mat-header-cell w-100">Created On</th>
           
        </tr>
        <tr class="mat-row">
            <td class="mat-cell">
                <mat-checkbox color="primary"></mat-checkbox>
            </td>
            <td class="mat-cell">
                <span class="taskname" >Real Estate</span>
            </td>
            <td class="mat-cell">
                3
            </td>
            <td class="mat-cell">
                Matt Macplin
            </td>
            <td class="mat-cell">
                Active
            </td>
            <td class="mat-cell">
                11/05/2020
            </td>
        </tr>
        <tr class="mat-row">
            <td class="mat-cell">
                <mat-checkbox color="primary"></mat-checkbox>
            </td>
            <td class="mat-cell">
                <span class="taskname" >Patient</span>
            </td>
            <td class="mat-cell">
                3
            </td>
            <td class="mat-cell">
                Matt Macplin
            </td>
            <td class="mat-cell">
                Draft
            </td>
            <td class="mat-cell">
                11/05/2020
            </td>
        </tr>
  
    </table>
</mat-card>
</div>

